
import { Component, Vue } from 'vue-property-decorator';
@Component({
    name:"Footer",
    props:{
        copyright:String
    }
})
export default class Footer extends Vue{
  
}
